import ErrorOutlineIcon from "@mui/icons-material/ErrorOutlineRounded";
import { Tooltip } from "@mui/material";
import type { FieldConfiguration } from "../../../../../../../../api/types/fieldConfigurationTypes.ts";
import type { ConditionField, DimensionDescriptor, ReportField } from "../../../../../../../../api/types/svTypes.ts";
import { isAggregation, isDateAggregationField } from "../../../../utilities/fieldsHelper.ts";
import FieldItemWithConditions from "../../../viewer/common/fields/FieldItemWithConditions.tsx";
import type { FieldItemProps } from "../../../viewer/common/fields/area-fields/areaFiledItem.types.ts";

interface Props<DimensionField> extends FieldItemProps<DimensionField> {
  detailedView?: boolean;
  dimensions: DimensionDescriptor[];
  globalConditions: ConditionField[];
  updateField: (field: ReportField, change: Partial<FieldConfiguration>) => void;
}

const DimensionItem = <T extends ReportField>({ field, ...props }: Props<T>) => (
  <FieldItemWithConditions
    {...props}
    field={field}
    supportsCustomConditions={isAggregation(field)}
    canToggleParameter
    isReadonlyCustomLabel
  >
    {isDateAggregationField(field) && field.invalid && (
      <Tooltip title="Invalid calculation: the field this date is based on has been removed or is no longer available. Edit the field to resolve.">
        <ErrorOutlineIcon color="secondary" sx={{ ml: 1 }} />
      </Tooltip>
    )}
  </FieldItemWithConditions>
);

export default DimensionItem;
